import { useState } from "react";
import { navLinks, siteName } from "@/mocks/home";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between gap-4 px-4 md:px-6">
        {/* logo */}
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
            78
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
            {siteName}
            <span className="ml-1 align-middle text-[11px] font-normal text-foreground-500">
              资讯
            </span>
          </span>
        </a>

        {/* desktop nav */}
        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className={
                link.active
                  ? "rounded-md px-3 py-2 text-sm font-medium text-primary-700"
                  : "rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
              }
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* right actions */}
        <div className="flex items-center gap-2">
          <button
            type="button"
            aria-label="搜索"
            onClick={() => setSearchOpen((v) => !v)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-foreground-300 hover:text-foreground-950"
          >
            <i className="ri-search-line text-base"></i>
          </button>
          <a
            href="#subscribe"
            className="hidden cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 sm:inline-flex"
          >
            订阅周报
          </a>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {/* search panel */}
      {searchOpen && (
        <div className="border-t border-background-200/70 bg-background-50">
          <div className="mx-auto max-w-[1280px] px-4 py-3 md:px-6">
            <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2">
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                type="text"
                placeholder="搜索作品、声优或资讯关键词"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <span>热门：</span>
              {["琉璃之城", "星轨协奏", "终末行纪", "秋番片单"].map((k) => (
                <span
                  key={k}
                  className="cursor-pointer rounded-full bg-secondary-100 px-2.5 py-1 text-secondary-900 transition-colors hover:bg-secondary-200"
                >
                  {k}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* mobile menu */}
      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 md:hidden">
          <nav className="mx-auto flex max-w-[1280px] flex-col px-4 py-2">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className={
                  link.active
                    ? "border-b border-background-100 py-3 text-sm font-medium text-primary-700"
                    : "border-b border-background-100 py-3 text-sm font-medium text-foreground-800"
                }
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-3 mb-2 cursor-pointer rounded-md bg-foreground-950 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              订阅周报
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}